import fb from './assets/facebook.svg';
import li from './assets/linkedin.svg';

export const FORMGROUP_ICONS = {
  fb,
  li,
};
